import { render, staticRenderFns } from "./ConfirmationReviewForm.vue?vue&type=template&id=390a3dd0&scoped=true&"
import script from "./ConfirmationReviewForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmationReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a3dd0",
  null
  
)

export default component.exports